import { render, staticRenderFns } from "./DeleteCompetitorDialog.vue?vue&type=template&id=0b80592a"
import script from "./DeleteCompetitorDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCompetitorDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteCompetitorDialog.vue?vue&type=style&index=0&id=0b80592a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports